import { render, staticRenderFns } from "./TblBasic.vue?vue&type=template&id=4fddc59d&scoped=true"
import script from "./TblBasic.vue?vue&type=script&lang=js"
export * from "./TblBasic.vue?vue&type=script&lang=js"
import style0 from "./TblBasic.vue?vue&type=style&index=0&id=4fddc59d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fddc59d",
  null
  
)

export default component.exports